const HeaderNavigation = function(settings) {
	"use strict";

	const _self = this;
	const _settings = {
		clicked: false
	};

	Object.assign(_settings, settings);

	function cacheDom() {
		_settings.$el = document.querySelector(_settings.el);
		_settings.$burger = _settings.$el.querySelector(_settings.burger);
		_settings.$mobileContainer = _settings.$el.querySelector(
			_settings.mobileContainer
		);
	}

	function bindEvents() {
		window.addEventListener("resize", handleResize);
		_settings.$burger.addEventListener("click", toggleHeaderNavigation);
	}

	function handleResize() {
		if (window.innerWidth > _settings.mobileViewport) {
			_settings.$mobileContainer.removeAttribute("tabIndex");
		} else {
			_settings.$mobileContainer.tabIndex = -1;
		}
	}

	function toggleHeaderNavigation() {
		_settings.$el.classList.toggle(_settings.headerOpenedClass);
		if (window.innerWidth <= _settings.mobileViewport) {
			document
				.querySelector("body")
				.classList.toggle(_settings.bodyClass);
		}
	}

	function init() {
		cacheDom();
		bindEvents();

		return _self;
	}

	return init();
};

export { HeaderNavigation };
